<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增主级
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" :scroll="{y:'70vh'}" :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a @click="addChildren(row)">新增下级</a>
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a style="padding-left:5px;color:red" @click="del(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible" title="编辑部门信息" ok-text="确定" cancel-text="取消" @ok="add"
                 @cancel="resetForm">
            <a-form-model ref="group" :rules="rules" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-form-model-item label="序号">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-form-model-item>
                <a-form-model-item label="部门名称" prop="name">
                    <a-input v-model.trim="form.name"/>
                </a-form-model-item>
                <a-form-model-item label="部门描述">
                    <a-input v-model.trim="form.descpt"/>
                </a-form-model-item>
                <a-form-model-item label="备注">
                    <a-input v-model="form.remark"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getGroupQueryList, groupEditDetail, groupDelDetail} from './js/ApiRole'

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '部门名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '部门描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
        },
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                visible: false,
                delVisible: false,
                rules: {
                    name: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
                },
                form: {
                    orderNo: '',
                    parentId: '0',
                    name: '',
                    descpt: '',
                    remark: '',
                },
                line: {}
            }
        },
        methods: {
            //新增
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.$refs.group.validate(valid => {
                    if (valid) {
                        groupEditDetail(this.form).then(() => {
                            this.getData()
                        })
                    }
                });
            },
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //新增子级
            addChildren(row) {
                this.form.parentId = row.id;
                this.visible = true
            },
            //删除
            del(row) {
                this.delVisible = true;
                this.line = row;
            },
            delOk(){
                groupDelDetail({id: this.line.id}).then(() => {
                    this.getData()
                    this.delVisible = false;
                }).catch(()=>{
                    this.delVisible = false;
                })
            },
            cancel(){
                this.delVisible = false;
            },
            getData(parameter) {
                this.resetForm();
                if (parameter === null || parameter === undefined) {
                    parameter = {}
                }
                getGroupQueryList(parameter).then(res => {
                    this.data = res.data;
                    this.visible = false
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                if (this.$refs.group !== undefined) {
                    this.$refs.group.clearValidate();
                }
                this.form = {
                    orderNo: '',
                    parentId: '0',
                    name: '',
                    descpt: '',
                    remark: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getGroupQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .Tips{
        font-size: 20px;
        color: #1890ff;
    }
</style>
